import { render, staticRenderFns } from "./POS.vue?vue&type=template&id=59c6e94a&scoped=true"
import script from "./POS.vue?vue&type=script&lang=js"
export * from "./POS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c6e94a",
  null
  
)

export default component.exports